export default __webpack_public_path__ + "static/media/tick-square.240f3cf7.svg";